import { render, staticRenderFns } from "./companyProfile.vue?vue&type=template&id=080fa5d6&scoped=true"
import script from "./companyProfile.vue?vue&type=script&lang=js"
export * from "./companyProfile.vue?vue&type=script&lang=js"
import style0 from "./companyProfile.vue?vue&type=style&index=0&id=080fa5d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080fa5d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080fa5d6')) {
      api.createRecord('080fa5d6', component.options)
    } else {
      api.reload('080fa5d6', component.options)
    }
    module.hot.accept("./companyProfile.vue?vue&type=template&id=080fa5d6&scoped=true", function () {
      api.rerender('080fa5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/training/companyProfile.vue"
export default component.exports